import { render } from "./SponsorAcquire.vue?vue&type=template&id=e5fc3bd0"
import script from "./SponsorAcquire.vue?vue&type=script&lang=js"
export * from "./SponsorAcquire.vue?vue&type=script&lang=js"

import "./SponsorAcquire.vue?vue&type=style&index=0&id=e5fc3bd0&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__